import { render } from "./DetailsView.vue?vue&type=template&id=23c2eec6&scoped=true"
import script from "./DetailsView.vue?vue&type=script&lang=js"
export * from "./DetailsView.vue?vue&type=script&lang=js"

import "./DetailsView.vue?vue&type=style&index=0&id=23c2eec6&scoped=true&lang=css"
import "./DetailsView.vue?vue&type=style&index=1&id=23c2eec6&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c2eec6"]])

export default __exports__